import React, { useCallback } from "react";
import VersionHistoryDialog from "./version-history-dialog";
import {
  fetchOfferTemplateVersions,
  restoreOfferTemplateVersion,
} from "../../../api/offer";

/**
 * Version history for an offer template (`is_template: true`).
 */
export default function OfferTemplateVersionHistoryDialog({
  open,
  onClose,
  offerId,
  onRestored,
}) {
  const fetchVersions = useCallback(
    (id) => fetchOfferTemplateVersions(id),
    []
  );
  const restoreVersion = useCallback(
    (id, versionId) => restoreOfferTemplateVersion(id, versionId),
    []
  );

  return (
    <VersionHistoryDialog
      open={open}
      onClose={onClose}
      title="offers.versions.template_title"
      entityId={offerId}
      fetchVersions={fetchVersions}
      restoreVersion={restoreVersion}
      onRestored={onRestored}
    />
  );
}
